
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoTypeGrid extends Serenity.EntityGrid<PsPromoTypeRow, any> {
        protected getColumnsKey() { return PsPromoTypeColumns.columnsKey; }
        protected getDialogType() { return PsPromoTypeDialog; }
        protected getIdProperty() { return PsPromoTypeRow.idProperty; }
        protected getInsertPermission() { return PsPromoTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoTypeRow.localTextPrefix; }
        protected getService() { return PsPromoTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsPromoTypeService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

    }
}